import React from 'react';
import { Redirect } from 'react-router-dom';

import { Loading } from '@deriv/components';
import { routes } from '@deriv/shared';
import { observer, useStore } from '@deriv/stores';

const RootComponent = observer(() => {
    const { client } = useStore();
    const { is_client_store_initialized } = client;

    if (!is_client_store_initialized) {
        return <Loading is_fullscreen />;
    }

    return <Redirect to={routes.trade} />;
});

export default RootComponent;
